import { GlRepository } from "../repositories/GlRepository";
import { GlOperationResult } from "../entities/GlEntity";

/**
 * Update GL Use Case
 * Updates an existing GL in Zoho and gl_map, or submits for review
 */
export class UpdateGlUseCase {
  constructor(private repository: GlRepository) {}

  async execute(
    accountId: string,
    payload: {
      account_name?: string;
      account_type?: string;
      parent_account_id?: string | null;
      invoice?: boolean;
      bill?: boolean;
      node_kind?: "ledger" | "group";
      request_comments?: string;
    }
  ): Promise<GlOperationResult> {
    return this.repository.updateGl(accountId, payload);
  }
}
